import { render, staticRenderFns } from "./DrawerTeamInstructor.vue?vue&type=template&id=712d822c"
import script from "./DrawerTeamInstructor.vue?vue&type=script&lang=js"
export * from "./DrawerTeamInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports